import { apiRequest } from "./client";
import type {
  CreateDiaryRequest,
  Diary,
  UpdateDiaryRequest,
} from "../types/diary";

export function getDiaries(): Promise<Diary[]> {
  return apiRequest<Diary[]>("/diaries");
}

export function getDiariesSortedByDateDesc(): Promise<Diary[]> {
  return apiRequest<Diary[]>("/diaries/ordered");
}

export function getDiaryById(id: number): Promise<Diary> {
  return apiRequest<Diary>(`/diaries/${id}`);
}

export async function createDiary(request: CreateDiaryRequest): Promise<Diary> {
  const token = localStorage.getItem("token");
  const response = await fetch("/api/v1/diaries", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(request),
  });

  if (!response.ok) {
    if (response.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    const msg = await response.text();
    throw new Error(msg || "Request failed");
  }

  return response.json() as Promise<Diary>;
}

export function updateDiary(
  id: number,
  request: UpdateDiaryRequest,
): Promise<Diary> {
  return apiRequest<Diary>(`/diaries/${id}`, {
    method: "PATCH",
    body: JSON.stringify(request),
  });
}

export function deleteDiary(id: number): Promise<void> {
  return apiRequest<void>(`/diaries/${id}`, {
    method: "DELETE",
  });
}

/**
 * Downloads all diary entries as a CSV file.
 * Uses fetch directly because the response is a file blob, not JSON.
 */
export async function downloadDiaryCsv(): Promise<void> {
  const token = localStorage.getItem("token");
  const response = await fetch("/api/v1/diaries/export/csv", {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });

  if (!response.ok) {
    if (response.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    throw new Error("CSV export failed");
  }

  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "valesco-diary-export.csv";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
